const idsTable = {
  arboles: "arb_int_id",
  seguimiento: "seg_int_id",
};

export default function idFieldSelector(type) {
  return idsTable[type];
}
